import React,{useState} from 'react';
import Table from "../../components/Table"
import StateContext from '../../helpers/ContextState';
import Config from '../../helpers/Config';

const App=(props)=>{
  const context = React.useContext(StateContext);
  const [param] = useState({tipo_usuario_id:2});

  let tds = [
    { 
      label:"Cliente", 
      value:"cliente", 
      className:"text-left", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"NIT", 
      value:"nro_documento_cliente", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Producto", 
      value:"producto", 
      className:"text-left", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Marca", 
      value:"marca", 
      className:"text-left", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Semestre", 
      value:"semestre", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Semana", 
      value:"semana_recibido", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"Fecha_Venta", 
      value:"fecha_venta_string", 
      className:"col-sm-1 text-center", 
      classNameHeader:"text-center" 
    },
    { 
      label:"Fecha_Compra", 
      value:"fecha_compra_string", 
      className:"col-sm-1 text-center", 
      classNameHeader:"text-center" 
    },
    { 
      total:true, 
      label:"Cantidad", 
      value:"cantidad_format", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      total:true, 
      label:"Peso", 
      value:"peso_format", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      label:"P_Unitario", 
      value:"precio_unit_string", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
    { 
      total:true, 
      label:"Total", 
      value:"subtotal_string", 
      className:"text-center", 
      classNameHeader:"col text-center" 
    },
  ]

  return <div className="container-fluid">
    <div className="row">
      <div className="col">
        <Table
          customFiltersI={true}
          total={true}
          toExport={Config.ConfigApirest+'Excel/Informes/ListadoProvisionVentaExcel/token:'+context.user.token}
          toPDF={Config.ConfigApirest+'PDF/Informes/ListadoProvisionVentaFiltro/'+context.user.token}
          td={tds}
          modelo="Informes"
          metodo="ListadoProvisionVentaFiltro"
          limit="10"
          params={param}
          totalizacion={true}
        />
      </div>
    </div>
  </div>
}
export default App
